@for (departmentGroup of departmentGroups; track departmentGroup; let i = $index) {
  <div class="multi-select__item">
    <div class="multi-select__item-title">
      <strong>Gruppenavn:</strong><span>{{ departmentGroup.name }}</span>
    </div>
    <button mat-icon-button title="Rediger" type="button" (click)="edit(i)" [disabled]="editMode">
      <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#edit-s"></use></svg>
    </button>
    <button mat-icon-button class="delete" title="Fjern" type="button" (click)="delete(i)" [disabled]="editMode">
      <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#trash-s"></use></svg>
    </button>
  </div>
}
